var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetentionRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "retention_rate",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 38,
    height: 38,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(6.859 3.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M168.029,54.091a1.179,1.179,0,1,1-1.179-1.179A1.179,1.179,0,0,1,168.029,54.091Z",
    transform: "translate(-165.671 -52.912)",
    fill: "#ffca5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arroq",
    transform: "translate(25.453 2.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M160.24,61.345h1.875a7.265,7.265,0,0,1,7.265,7.265v1.875",
    transform: "translate(-160.24 -59.281)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M162.3,63.347l-2.063-2.063L162.3,59.22l-2.063,2.064",
    transform: "translate(-160.24 -59.22)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(3.856 24.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M154.151,85.058h-1.876a7.263,7.263,0,0,1-7.264-7.264V75.918",
    transform: "translate(-145.011 -75.918)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M152.3,83.2l2.063,2.063L152.3,87.332l2.063-2.063",
    transform: "translate(-145.22 -76.127)",
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Balance",
    transform: "translate(7.789 7.788)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 11.117,
    cy: 11.117,
    rx: 11.117,
    ry: 11.117,
    fill: "none",
    stroke: "#3c4043",
    strokeMiterlimit: 2.613,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M176.506,83.311a9.083,9.083,0,1,1-9.082-9.082A9.082,9.082,0,0,1,176.506,83.311Z",
    transform: "translate(-156.325 -72.213)",
    fill: "#ffbb39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "percent-2",
    transform: "translate(4.567 5.741) rotate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(0.004 0.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M10.434.146a.5.5,0,0,0-.7,0L.146,9.756a.5.5,0,1,0,.7.7L10.434.85A.5.5,0,0,0,10.434.146Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M2.533,0A2.533,2.533,0,1,0,5.066,2.533,2.536,2.536,0,0,0,2.533,0Zm0,4A1.467,1.467,0,1,1,4,2.533,1.468,1.468,0,0,1,2.533,4Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(5.433 7.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M2.533,0A2.533,2.533,0,1,0,5.066,2.533,2.536,2.536,0,0,0,2.533,0Zm0,4A1.467,1.467,0,1,1,4,2.533,1.468,1.468,0,0,1,2.533,4Z",
    fill: "#3c4043",
    stroke: "#3c4043",
    strokeWidth: 0.3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Polygon",
    transform: "translate(29.279 30.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M176.238,72.514l2.092-3.623,2.092,3.623Z",
    transform: "translate(-176.238 -68.891)",
    fill: "none",
    stroke: "#5fb4f6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetentionRate);
export default __webpack_public_path__ + "static/media/retention_rate.eabbf9191eff427c35bc30ac998f6ba3.svg";
export { ForwardRef as ReactComponent };